

















































import { Component, Vue } from 'vue-property-decorator'
import { routes, social } from '@/router'

@Component({
  components: {
  },
})
export default class App extends Vue {
  public Routes = routes;
  public Social = social;

  public Navigate(path: string): void {
    this.$router.push(path);
  }
}
